import React, { createContext, FC, useContext } from 'react';
import dynamic from 'next/dynamic';
import Box from '@/components/UI/box/Box';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from './ProductCard.module.scss';
import ProductCardBookmark from './productCardBookmark/ProductCardBookmark';
import ProductImages from './productCardImages/ProductCardImages';
import heap from '@/helpers/heap';
import Image from 'next/image';
import { ProductListRecord } from './types';
import ProductCardMidTerm from './productCardMidTerm/ProductCardMidTerm';
import ProductCardShortTerm from './productCardShortTerm/ProductCardShortTerm';
import ProductCardMidtermBadge from './productCardMidtermBadge/ProductCardMidtermBadge';
import ProductCardPricingDetails from './productCardShortTerm/productCardPricingDetails/ProductCardPricingDetails';
import ProductCardMidTermFooter from './productCardMidTermFooter/ProductCardMidTermFooter';
const ProductCardBadges = dynamic(() => import('@/components/reusable/productCard/productCardBadges/ProductCardBadges'), {
  ssr: false
});
type ProductCardProps = {
  data: ProductListRecord;
  isShowMap?: boolean;
  index?: number;
  isCarousel?: boolean;
  lateNight?: boolean;
  searchId?: string;
  isFirstCard?: boolean;
};
const ProductCard: FC<ProductCardProps> = ({
  data,
  isShowMap,
  index,
  isCarousel,
  lateNight,
  searchId,
  isFirstCard
}) => {
  const router = useRouter();
  const mapItemContext = createContext<(id) => void>(() => ({
    current: null
  }));
  const mapHoverRef = useContext<any>(mapItemContext);
  const cardHref = {
    pathname: `/houses/show/${data?.id}`,
    query: {
      ...(router.query?.cancel_link_type && {
        cancel_link_type: router.query?.cancel_link_type
      }),
      ...(searchId && router.asPath.includes('/search') && {
        search_id: searchId
      }),
      ...(router.query.mid_term && router.asPath.includes('/search') && {
        mid_term: 1
      }),
      ...(data.badges.includes('is_ad') && router.asPath.includes('/search') && {
        is_ad: 1
      })
    }
  };
  const handlePreventChangeRoute = e => {
    document.querySelectorAll('#navigation-button-right').forEach(item => {
      if (item.contains(e.target)) {
        e.preventDefault();
      }
    });
    document.querySelectorAll('#navigation-button-left').forEach(item => {
      if (item.contains(e.target)) {
        e.preventDefault();
      }
    });
    document.querySelectorAll('#home-card-fave').forEach(item => {
      if (item.contains(e.target)) {
        e.preventDefault();
      }
    });
  };

  // Heap Event
  const handleHeapEvent = () => {
    heap.track('product_card_click', {
      is_ads: !!data?.badges?.includes('is_ad'),
      city_name: data?.location?.city,
      house_id: data?.id,
      position: index,
      ismidterm: data?.location?.city === 'تهران' && router?.query?.mid_term === '1',
      page: router.asPath.includes('/search') ? router.query.page || 1 : 'not set'
    });
  };
  const getCardAsPath = (id: string | number): string => {
    const params = new URLSearchParams();
    if (router.query.mid_term) params.set('mid_term', '1');
    const queryString = params.toString();
    return `/houses/show/${id}${queryString ? `?${queryString}` : ''}`;
  };
  const handleOpenHouse = () => {
    router.push(cardHref, getCardAsPath(data?.id));
  };
  return <Box onMouseEnter={() => {
    mapHoverRef && mapHoverRef?.current?.setMapHover(+data?.id);
  }} onMouseLeave={() => {
    mapHoverRef && mapHoverRef?.current?.setMapHover(null);
  }} onClick={handleHeapEvent} className={isShowMap ? styles['product_card_container_with_map'] : styles['product_card_container']} component={'article'} data-sentry-element="Box" data-sentry-component="ProductCard" data-sentry-source-file="ProductCard.tsx">
      <Box component={'header'} className={styles['product-card-header']} data-sentry-element="Box" data-sentry-source-file="ProductCard.tsx">
        <Link href={cardHref} className={styles['title_section']} data-house-id={data?.id} data-index={index} as={getCardAsPath(data?.id)} data-sentry-element="Link" data-sentry-source-file="ProductCard.tsx">
          <Box className={styles['images_container']} onClick={handlePreventChangeRoute} data-sentry-element="Box" data-sentry-source-file="ProductCard.tsx">
            <ProductCardBadges possible_discount_days={data?.pricing?.possible_discount_days} is_installment_payment={false} data-sentry-element="ProductCardBadges" data-sentry-source-file="ProductCard.tsx" />
            <Box className={styles['badges_bookmark_container']} data-sentry-element="Box" data-sentry-source-file="ProductCard.tsx">
              <ProductCardBookmark id={data?.id} data-sentry-element="ProductCardBookmark" data-sentry-source-file="ProductCard.tsx" />
            </Box>
            {router.query?.mid_term && <ProductCardMidtermBadge hasVideo={data?.badges?.includes('has_video')} />}
            {isCarousel ? <Box className={styles['carousel-image-container']} component={'figure'}>
                <Image fill={true} objectFit="cover" loading={'lazy'} src={data?.cover_photo?.thumbnail_absolute_url} alt={data?.title} />
              </Box> : <ProductImages thumbnail={data?.cover_photo?.thumbnail_absolute_url} pictures={data?.with?.photos} title={data?.title} isFirstCard={isFirstCard} />}
          </Box>
        </Link>
        {router.query?.mid_term ? <ProductCardMidTerm data={data} index={index} cardHref={cardHref} handleOpenHouse={handleOpenHouse} redirectLink={getCardAsPath(data?.id)} /> : <ProductCardShortTerm data={data} index={index} cardHref={cardHref} isCarousel={isCarousel} handleOpenHouse={handleOpenHouse} redirectLink={getCardAsPath(data?.id)} />}
      </Box>
      {router.query?.mid_term ? <ProductCardMidTermFooter data={data} handleOpenHouse={handleOpenHouse} /> : <Box component={'footer'} className={styles['price_section']} onClick={handleOpenHouse}>
          <ProductCardPricingDetails pricing={data?.pricing} lateNight={lateNight} />
        </Box>}
    </Box>;
};
export default ProductCard;